import { render } from "./Vacancies.vue?vue&type=template&id=0dce3afc&scoped=true"
import script from "./Vacancies.vue?vue&type=script&lang=js"
export * from "./Vacancies.vue?vue&type=script&lang=js"

import "./Vacancies.vue?vue&type=style&index=0&id=0dce3afc&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dce3afc"]])

export default __exports__